var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { translateString } from "@/components/forms/components/utils";
import { faHomeAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";
export default function Menu() {
    var location = useLocation();
    var breadcrumb = function () {
        var parts = location.pathname.split("/");
        var items = [];
        var elementPath = function (array, index) {
            if (index <= 0) {
                return "";
            }
            var element = array[index];
            return elementPath(array, index - 1) + "/" + element;
        };
        for (var i = 0; i < parts.length; i++) {
            var element = parts[i];
            if (element !== "" && element !== location.pathname) {
                items.push({
                    name: element,
                    path: elementPath(parts, i),
                    root: items.length === 0,
                });
            }
        }
        return items;
    };
    return (_jsxs("div", __assign({ className: "flex overflow-hidden flex-col" }, { children: [_jsx("nav", __assign({ className: "breadcrumb", "aria-label": "breadcrumbs" }, { children: _jsx("ul", __assign({ className: "flex flex-1 flex-row " }, { children: 
                    /*breadcrumb().length === 9 ? (
                    <></>
                  ) : (*/
                    breadcrumb().map(function (item, index) { return (_jsx("li", { children: item.root ? (_jsx(Link, __assign({ className: " cursor-pointer", to: "".concat(item.path, "/ModuleBuilder") }, { children: _jsx(FontAwesomeIcon, { icon: faHomeAlt, color: "var(--color-blue-800)" }) }))) : (item.name != "ModuleBuilder" && (_jsx(Link, __assign({ to: item.path }, { children: _jsxs("label", __assign({ className: "text-[rgb(var(--color-blue-800))] cursor-pointer" }, { children: [_jsxs("span", __assign({ className: "px-2 text-[rgb(var(--color-gray-500))]" }, { children: ["/", " "] })), " ", translateString(item.name, "ModuleBuilder").toLocaleLowerCase()] })) })))) }, index)); }) })) })), _jsx("div", {})] })));
}
